<template>
  <el-dropdown trigger="click" class="notification-center" @command="onCommand">
    <span class="notification-center__trigger">
      <el-badge :value="totalCount" :hidden="totalCount === 0" type="warning">
        <i class="fa fa-bell fa-fw fa-lg"></i>
      </el-badge>
    </span>
    <el-dropdown-menu slot="dropdown" class="notification-center__menu">
      <el-dropdown-item
          v-for="(item, index) in notifications"
          :key="index"
          :command="item.url"
      >
        <span class="notification-center__item">
          <i :class="iconFor(item.type)" class="notification-center__icon"></i>
          <span class="notification-center__message">{{ item.message }}</span>
        </span>
      </el-dropdown-item>
      <el-dropdown-item v-if="notifications.length === 0" disabled>
        <span class="notification-center__item notification-center__item--empty">
          <i class="far fa-bell-slash notification-center__icon"></i>
          <span class="notification-center__message">No notifications</span>
        </span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import eventBus from '../event-bus';

// Maps a notification type to its icon, keeping presentation in the frontend.
const ICONS = {
  'pending-approval': 'fas fa-comment-medical',
};

const DEFAULT_ICON = 'far fa-bell';

export default {
  data() {
    return {
      notifications: config('notifications', []) || [],
      pollInterval: null,
    };
  },

  computed: {
    /**
     * @return {number}
     */
    totalCount() {
      return this.notifications.reduce((sum, item) => sum + (Number(item.count) || 0), 0);
    },
  },

  methods: {
    /**
     * @param {string} type
     * @return {string}
     */
    iconFor(type) {
      return ICONS[type] || DEFAULT_ICON;
    },

    /**
     * Re-fetch notifications so the bell stays current without a page reload
     * (e.g. after a message is approved or rejected).
     *
     * @return {undefined}
     */
    refresh() {
      const url = config('notificationsUrl');

      if (!url) {
        return;
      }

      axios.get(url)
          .then(({data}) => this.notifications = _.get(data, 'notifications', []))
          .catch(() => {});
    },

    /**
     * @param {string|null} url
     */
    onCommand(url) {
      if (url) {
        window.location.href = url;
      }
    },
  },

  created() {
    eventBus.$on('notifications:refresh', this.refresh);
    this.pollInterval = setInterval(this.refresh, config('notificationsPollInterval', 30000));
  },

  beforeDestroy() {
    eventBus.$off('notifications:refresh', this.refresh);
    clearInterval(this.pollInterval);
  },
};
</script>

<style scoped>
.notification-center__trigger {
  cursor: pointer;
}

.notification-center__menu {
  min-width: 240px;
}

.notification-center__item {
  display: flex;
  align-items: center;
}

.notification-center__icon {
  width: 1.25rem;
  margin-right: 0.5rem;
  text-align: center;
  color: #e6a23c;
}

.notification-center__item--empty .notification-center__icon,
.notification-center__item--empty .notification-center__message {
  color: #909399;
}
</style>
